export default function last<T>(arr: T[]): T {
  return arr[arr.length - 1];
}
